export default "__VITE_ASSET__7186237b__"